const state = {
    user: null, //changed from localStorage
    userId: null,
    firstName: null,
    token: localStorage.getItem('token'),
    restrictions: [],
    permissions: [],
    excludePartialItems: false,
    logged: false,
    loginFailed: false,
    loginInfoText: null,
    userRole: null,
    headerText: 'Bitte melde dich an.',
    headerVisibility: true,

    overlayVisibility: false,
    overlayContent: null,

    topScroll: false,

    cartContentVisibility: false,
    scannerVisibility: false,
    drawerVisibility: false,
    isLoading: true,
    categoryBreadcrumbs: [],
    categories: [],
    currentCategory: null,
    order: null,

    cartContentCounter: 0,
    cartContents: [],
    totalPrice: null,
    lastWatched: [],
    watchlist:[],
    searchResult: [],

    notificationTxt: '',
    showNotification: false,

    cartDrawerState: false,
    barcodeScannerState: false,

    sideDrawerState: false,

    depositStartCheck: null,
    depositReset: null,
    depositCollector: [],
    depositOverview: {},
    continuedDeposit: null,
    depositOverlayVisibility: false,
    depositOverlayContent: null,

    signaturePadState: null,
    signatureSVG: null,

    allowedDates: null,

    issueMore: false,
    currentPage: 1,
    currentPosition: null,
    storedCategoryProducts: [],


    // tourdata
  requestStateTourData: null,
  requestPendingTourData: false,
  loadingOverlayTourData: false,

    currentCategoryPosition: [],

    searchResultsArticles: null,

    newsAvailable: false,

    version: '1.6.13.5',

    currentActiveMode: localStorage.getItem('currentActiveMode') ? localStorage.getItem('currentActiveMode') : null
}

export default state
